import jsPDF from 'jspdf';
import { STATES } from '../Constants';
import {
    formatNumber, format_invoice, getTimeInIST,
    // numberToText, precision, titleCase, 
    toInt
} from '../Utils';

// const getRupeeSymbol = (doc, x, y) => {
//     doc.text('INR', x, y);
//     // let rupee = "data:image/png;base64,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";
//     // doc.addImage(rupee, 'PNG', column7X - 24, initialTableDataHeight + (index * item_lineheight) - 2.5, 2.5, 2.5);
// }

export const showPackingList = (shipment, master_items) => {
    var doc = new jsPDF({
        orientation: 'portrait',
        format: 'a4',
        compress: true
    });
    doc.cellInitialize();
    doc.setFontSize(14);
    doc.setLineHeightFactor(0.5);
    doc.setFont("times", 'bold');
    let c = 1;
    let data = [];

    shipment.items.forEach(item => {
        let i = 1;
        for (; i <= item.no_of_cases; i++) {
            let fnsku = master_items.filter(i => i.id === item.item_id)[0].fnsku;
            data.push({ "item": item.item_name, "carton_no": `${c++}`, "fnsku": fnsku, "case_size": toInt(item.case_size) + "pcs", "weight": item.weight + " KG", "dimension": item.dimension || "-" });
        }
    });

    doc.text("Packing List", 10, 10);
    doc.cell(10, 20, 60, 10, "Shipment ID", 1, "center");
    doc.cell(10, 20, 60, 10, shipment.shipment_identifier || '', 1, "center");
    doc.cell(10, 20, 60, 10, "Invoice No", 2, "center");
    doc.cell(10, 20, 60, 10, shipment.invoice_no, 2, "center");
    doc.cell(10, 20, 60, 10, "Shipment Date", 3, "center");
    doc.cell(10, 20, 60, 10, getTimeInIST(shipment.shipment_date).format(format_invoice), 3, "center");
    doc.cell(10, 20, 60, 10, "Warehouse", 4, "center");
    doc.cell(10, 20, 60, 10, shipment.warehouse_name, 4, "center");
    doc.cell(10, 20, 60, 10, "Fulfillment Center", 5, "center");
    doc.cell(10, 20, 60, 10, shipment.fc_name, 5, "center");

    var header = [
        {
            'name': 'item',
            'prompt': "Item",
            'width': 100,
            'align': 'center',
            'padding': 0
        }, {
            'name': 'carton_no',
            'prompt': "Carton \n\nNo.",
            'width': 27,
            'align': 'right',
            'padding': 0
        }, {
            'name': "fnsku",
            'prompt': "FNSKU",
            'width': 45,
            'align': 'center',
            'padding': 0
        }, {
            'name': "case_size",
            'prompt': "Case Size",
            'width': 32,
            'align': 'center',
            'padding': 0
        }, {
            'name': 'weight',
            'prompt': 'Weight',
            'width': 25,
            'align': 'right',
            'padding': 0
        }, {
            'name': 'dimension',
            'prompt': 'dimension',
            'width': 38,
            'align': 'left',
            'padding': 0
        }];

    doc.table(5, 100, data, header, { headerBackgroundColor: [255, 255, 255], autoSize: false });

    let filename = `${shipment.shipment_identifier || ''}_${shipment.fc_name}_GST${shipment.invoice_no.substring(shipment.invoice_no.lastIndexOf("/") + 1)}_PackingList.pdf`;
    doc.save(filename);
    // function open_data_uri_window(url, filename) {
    //     var html = '<html>' +
    //         '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
    //         '<body>' +
    //         '<iframe src="' + url + '" download="abhi.pdf"></iframe>' +
    //         '<a href="'+url+'" download="'+filename+'"></a>' +
    //         '</body></html>';
    //     var a = window.open("about:blank", "Zupfnoter");
    //     a.document.write(html);
    //     a.document.close();
    // }

    // let a = doc.output('datauristring', {filename: filename});
    // open_data_uri_window(a, filename);
}

export const printLabel = (shipment) => {
    // this.handleShowOutput();
    console.log(shipment)
    var doc = new jsPDF({
        orientation: 'landscape',
        format: 'a6',
        compress: true
    });
    // doc.cellInitialize();
    doc.setFontSize(14);
    // doc.setLineHeightFactor(0.5);
    doc.setFont("times", 'bold')
    let label_data = [];

    shipment.cartons.forEach((carton, index) => {
        label_data.push([
            { x: "Shipment ID:", y: shipment.shipment_identifier || '' },
            { x: "FC Name:", y: shipment.fc_name },
            { x: "Carton No.", y: `${index + 1}` },
            { x: "Carton Weight:", y: `${carton.weight} KG` }
        ]);
    });
    label_data.forEach((e, i) => {
        e.forEach((element, index) => {
            doc.cell(10, 10, 60, 10, element.x, index, "center");
            doc.cell(10, 10, 60, 10, element.y, index, "center");
        });
        if (i < label_data.length - 1) {
            doc.cellAddPage();
        }
    });
    //   doc.output("dataurlnewwindow");
    // doc.save("Labels-"+shipment.id);
    // doc.setDocumentProperties({
    //         'title': 'Labellllll.pdf'
    // })
    let filename = `${shipment.shipment_identifier || ''}_${shipment.fc_name}_GST${shipment.invoice_no.substring(shipment.invoice_no.lastIndexOf("/") + 1)}_Labels.pdf`;
    // doc.output("dataurlnewwindow",{filename: filename});
    // let output = doc.output('datauristring', {filename: filename});
    doc.save(filename);

    // function open_data_uri_window(url, filename) {
    //     var html = '<html>' +
    //         '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
    //         '<body>' +
    //         '<iframe src="' + url + '" download="abhi.pdf"></iframe>' +
    //         '<a href="'+url+'" download="'+filename+'"></a>' +
    //         '</body></html>';
    //     var a = window.open("about:blank", "Zupfnoter");
    //     a.document.write(html);
    //     a.document.close();
    // }

    // let a = doc.output('datauristring', {filename: filename});
    // open_data_uri_window(a, filename);
}

export const printInvoice = (shipment, master_items, company_data, master_warehouse, master_fc,) => {
    // this.handleShowOutput();
    let company = company_data;
    var doc = new jsPDF({
        orientation: 'portrait',
        format: 'a4',
        compress: true
    });

    //Initial
    // Delivery Challan
    let startX = 10;
    let startY = 10;
    let endX = doc.internal.pageSize.width - 20;
    let endY = doc.internal.pageSize.height - 20;
    let contentEndX = endX + 10;
    let contentEndY = endY + 10;
    let contentcenter = startX + (contentEndX - 10) / 2;

    let warehouse = master_warehouse.filter(w => w.id === shipment.warehouse_id)[0];
    let fc = master_fc.filter(fc => fc.id === shipment.fc_id)[0];
    const total_cartons = shipment.cartons.length || 0
    // const total_units = shipment.items.reduce((sum, next) => sum + next.units, 0);
    //Heading Section

    doc.setFontSize(14);
    doc.setLineHeightFactor(0.5);

    startX = 10;
    startY = 20;
    endX = doc.internal.pageSize.width - 20;
    endY = doc.internal.pageSize.height - 20;
    doc.setLineWidth(0.25)
    doc.rect(startX, 10, endX, startY);
    doc.rect(startX, startY + 10, endX, startY + 20);
    doc.rect(startX, startY + 50, endX, startY + 20);

    doc.setFont("times", '', 'normal')
    doc.setFontSize(14);
    doc.setFont("times", 'bold')
    //SECTION 1
    doc.text(company.name, contentcenter, 16, { align: "center", maxWidth: contentEndX - 10 });
    doc.setFontSize(10);
    doc.setFont("times", '', 'normal')
    doc.text(`${warehouse.address1 ? `${warehouse.address1}, ` : ''}${warehouse.address2 ? `${warehouse.address2}, ` : ''}${warehouse.city ? `${warehouse.city}, ` : ''}${warehouse.district ? `${warehouse.district}, ` : ''}${warehouse.state ? `${warehouse.state} ` : ''}${warehouse.pin ? `- ${warehouse.pin}` : ''}`, contentcenter, 21, { align: "center", maxWidth: contentEndX - 10 });
    doc.setFont("times", 'bold')
    doc.text(`DELIVERY CHALLAN/ TAX INVOICE`, contentcenter, startY + 7, { align: "center", maxWidth: contentEndX - 10 });
    //SECTION 2
    doc.setFont("times", '', 'normal')
    doc.setFontSize(8);
    doc.setFont("times", 'bold')
    doc.text(`Ship From:`, startX + 5, startY + 17, { align: "left", maxWidth: contentEndX / 3 });
    doc.setFont("times", '', 'normal')
    doc.setFontSize(8);
    doc.setFont("times", '', 'normal')
    let billFrom = startY + 22
    let vhDiff = 4
    doc.text(warehouse.name, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    billFrom += vhDiff
    doc.text(warehouse.address1, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    if (warehouse.address2) {
        billFrom += vhDiff
        doc.text(warehouse.address2, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    }
    if (warehouse.city || warehouse.district) {
        billFrom += vhDiff
        doc.text(`${warehouse.city ? `${warehouse.city}, ` : ''}${warehouse.district ? `${warehouse.district}, ` : ''}`, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    }
    billFrom += vhDiff
    let state = STATES.find(x => x.label === warehouse.state);
    doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    billFrom += vhDiff
    doc.text(warehouse.pin, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    billFrom += vhDiff
    doc.setFont("times", 'bold')
    doc.text(`GSTIN`, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    doc.setFont("times", '', 'normal')
    doc.text(warehouse.gst, startX + 5 + 10, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    // Ship To
    let billFromX = startX + 5 + contentEndX / 3 - 15
    doc.setFont("times", 'bold')
    doc.text(`Ship To:`, billFromX, startY + 17, { align: "left", maxWidth: contentEndX / 3 });
    doc.setFont("times", '', 'normal')
    billFrom = startY + 22
    doc.text(fc.name, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    billFrom += vhDiff
    doc.text(fc.address1, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    if (fc.address2) {
        billFrom += vhDiff
        doc.text(fc.address2, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    }
    if (fc.address3) {
        billFrom += vhDiff
        doc.text(fc.address3, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    }
    billFrom += vhDiff
    state = STATES.find(x => x.label === fc.address4);
    doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    billFrom += vhDiff
    doc.setFont("times", 'bold')
    doc.text(`GSTIN`, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    doc.setFont("times", '', 'normal')
    doc.text(fc.gstin, billFromX + 10, billFrom, { align: "left", maxWidth: contentEndX / 3 });

    billFromX = startX + 5 + (contentEndX * 2 / 3) - 15
    billFrom = startY + 30
    doc.setFont("times", 'bold')
    doc.text('Place of supply :', billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    doc.setFont("times", '', 'normal')
    doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, billFromX + 22, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    billFrom += vhDiff
    doc.setFont("times", 'bold')
    doc.text('Place of supply :', billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
    doc.setFont("times", '', 'normal')
    doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, billFromX + 22, billFrom, { align: "left", maxWidth: contentEndX / 3 });

    //SECTION 3
    let section3X = startX + 5
    let section3Y = billFrom + 20
    let vwDiff = 40
    vhDiff = 0
    doc.setFont("times", '', 'normal')
    doc.setFontSize(8);
    doc.setFont("times", '', 'normal')
    doc.text(`Document Number`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    doc.text(`${shipment.shipment_identifier || ''}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    vhDiff += 4
    doc.text(`FBA Shipment ID`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    doc.text(`${shipment.shipment_identifier || ''}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    vhDiff += 4
    doc.text(`IRN Number (Optional)`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    doc.text(`${''}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    vhDiff += 4
    doc.text(`Invoice Number`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    doc.text(`${shipment.invoice_no}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    vhDiff += 4
    doc.text(`Document Date`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    doc.text(`${getTimeInIST(shipment.shipment_date).format(format_invoice)}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    vhDiff += 4
    doc.text(`Purpose of transfer`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    doc.text(`Stock Transfer`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    vhDiff += 4
    doc.text(`Number of box`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
    doc.text(`${total_cartons}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });

    // Section 4
    let section4X = startX
    let section4Y = section3Y + vhDiff + 2
    let igstBilling = shipment.interstate === 1
    let data = []
    let tq = 0, uv = 0, tv = 0, iv = 0, sv = 0, cv = 0
    shipment.items.forEach((item, i) => {
        let totalQty = toInt(item.units)
        tq += totalQty
        uv += parseFloat(item.rate || 0)
        tv += parseFloat(parseFloat(item.rate || 0) * parseFloat(totalQty))
        cv += parseFloat(igstBilling ? 0 : ((parseFloat(totalQty) * parseFloat(item.rate)) * parseFloat(item.cgst || 0) / 100))
        sv += parseFloat(igstBilling ? 0 : ((parseFloat(totalQty) * parseFloat(item.rate)) * parseFloat(item.sgst || 0) / 100))
        iv += parseFloat(igstBilling ? ((parseFloat(totalQty) * parseFloat(item.rate)) * parseFloat(item.igst || 0) / 100) : 0)
        data.push({
            "index": `${i + 1}`,
            "item": `${item.item_name}`,
            "qty": `${totalQty || 0}`,
            "unit_value": `${formatNumber(item.rate || 0)}`,
            "hsn": `${item.hsn_code}`,
            "total_value": `${formatNumber((item.rate || 0) * totalQty)}`,
            "cgst_rate": `${igstBilling ? 0 : formatNumber(item.cgst)}`,
            "cgst_value": `${igstBilling ? 0 : formatNumber((totalQty * item.rate) * parseFloat(item.cgst || 0) / 100)}`,
            "sgst_rate": `${igstBilling ? 0 : formatNumber(item.sgst)}`,
            "sgst_value": `${igstBilling ? 0 : formatNumber((totalQty * item.rate) * parseFloat(item.sgst || 0) / 100)}`,
            "igst_rate": `${igstBilling ? formatNumber(item.igst) : 0}`,
            "igst_value": `${igstBilling ? formatNumber((totalQty * item.rate) * parseFloat(item.igst || 0) / 100) : 0}`,
        });
        // }
    });

    data.push({
        "index": `   `,
        "item": `Total`,
        "qty": `${tq || 0}`,
        "unit_value": `${formatNumber(uv || 0)}`,
        "hsn": `   `,
        "total_value": `${formatNumber(tv || 0)}`,
        "cgst_rate": `   `,
        "cgst_value": `${formatNumber(cv || 0)}`,
        "sgst_rate": `   `,
        "sgst_value": `${formatNumber(sv || 0)}`,
        "igst_rate": `  `,
        "igst_value": `${formatNumber(iv || 0)}`,
    })

    let header = [
        {
            'name': 'index',
            'prompt': "Sno",
            'width': 13,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'item',
            'prompt': "Product Description",
            'width': 55.5,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'qty',
            'prompt': "Qty",
            'width': 15,
            'align': 'left',
            'padding': 0
        }, {
            'name': "unit_value",
            'prompt': "Unit\n\nValue",
            'width': 20,
            'align': 'center',
            'padding': 0
        }, {
            'name': "hsn",
            'prompt': "HSN /\n\nSAC\n\nCode",
            'width': 21,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'total_value',
            'prompt': 'Total\n\nValue\n\n(INR)',
            'width': 22,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'cgst_rate',
            'prompt': 'CGST\n\nRate\n\n(%)',
            'width': 16,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'cgst_value',
            'prompt': 'CGST\n\nValue\n\n(INR)',
            'width': 20,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'sgst_rate',
            'prompt': 'SGST\n\nRate\n\n(%)',
            'width': 16,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'sgst_value',
            'prompt': 'SGST\n\nValue\n\n(INR)',
            'width': 20,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'igst_rate',
            'prompt': 'IGST\n\nRate\n\n(%)',
            'width': 15,
            'align': 'left',
            'padding': 0
        }, {
            'name': 'igst_value',
            'prompt': 'IGST\n\nValue\n\n(INR)',
            'width': 20,
            'align': 'left',
            'padding': 0
        }];

    let section5Y = section4Y + 5

    doc.table(section4X, section4Y, data, header, {
        headerBackgroundColor: "#FFFFFF",
        autoSize: false,
        fontSize: 6,
        rowStart: (e) => {
            section5Y += 8
            if (e.row === data.length - 1) {
                doc.setFont("times", 'bold');
            }
            else {
                doc.setFont("times", '', 'normal');
            }
        },
    });

    let section5AY = section5Y + 3 + (data.length > 5 ? 0 : 3);
    doc.rect(startX, section5AY, endX, 7);
    doc.setFontSize(8)
    doc.setFont('times', 'bold')
    doc.text(`Total Value of Goods Incl. Tax INR ${formatNumber((parseFloat(tv) + parseFloat(sv) + parseFloat(cv) + parseFloat(iv)) || 0)}`, startX + 10, section5AY + 5)

    // Section 6
    let section6Y = section5Y + 10 + 5
    doc.rect(startX, section6Y, endX, 23);
    doc.text(`Declaration`, contentcenter, section6Y + 6, { align: "center", width: contentEndY })
    doc.setFont('times', '', 'normal')
    doc.text(`We declare that`, startX + 5, section6Y + 9, { align: "left", width: contentEndY })
    doc.text(`1. The above mentioned goods are being moved from our premises for branch transfer`, startX + 7, section6Y + 14, { align: "left", width: contentEndY })
    doc.text(`2. The above mentioned details are true and correct to the best of our knowledge`, startX + 7, section6Y + 19, { align: "left", width: contentEndY })
    doc.rect(startX, section6Y + 23, endX, 40);
    doc.setFont('times', 'bold')
    doc.text(`For ${company.name}`, startX + 10, section6Y + 30, { align: "left", width: contentEndY })
    doc.setFont('times', '', 'normal')
    doc.text(`Authorized Signatory`, startX + 13, section6Y + 60, { align: "left", width: contentEndY })

    // Next Page - Packaging list
    doc.cellAddPage()
    doc.setFontSize(12);
    // doc.setLineWidth(0.75)
    doc.setLineHeightFactor(1);
    doc.setFont("times", 'bold')
    data = [];

    doc.text("Packing List", 10, 10);
    doc.cell(10, 20, 60, 10, "Shipment ID", 1);
    doc.cell(10, 20, 60, 10, shipment.shipment_identifier || '', 1, "center");
    doc.cell(10, 20, 60, 10, "Invoice No", 2, "center");
    doc.cell(10, 20, 60, 10, shipment.invoice_no, 2, "center");
    doc.cell(10, 20, 60, 10, "Shipment Date", 3, "center");
    doc.cell(10, 20, 60, 10, getTimeInIST(shipment.shipment_date).format(format_invoice), 3, "center");
    doc.cell(10, 20, 60, 10, "Warehouse", 4, "center");
    doc.cell(10, 20, 60, 10, shipment.warehouse_name, 4, "center");
    doc.cell(10, 20, 60, 10, "Fulfillment Center", 5, "center");
    doc.cell(10, 20, 60, 10, shipment.fc_name, 5, "center");
    doc.cell(10, 20, 60, 10, "Total No of Cartons", 6, "center");
    doc.cell(10, 20, 60, 10, `${shipment.cartons.length || 0}`, 6, "center");
    doc.cell(10, 20, 60, 10, "Total No of Units", 7, "center");
    doc.cell(10, 20, 60, 10, `${shipment.items.reduce((sum, next) => sum + next.units, 0) || 0}`, 7, "center");

    header = [
        {
            'name': 'item',
            'prompt': "Item",
            'width': 120,
            'align': 'left',
        }, {
            'name': "fnsku",
            'prompt': "FNSKU",
            'width': 45,
            'align': 'left',
        }, {
            'name': "units",
            'prompt': "Units",
            'width': 32,
            'align': 'center',
        }
    ];
    shipment.items.forEach(item => {
        let fnsku = master_items.find(i => i.id === item.item_id).fnsku;
        data.push({
            item: item.item_name,
            fnsku,
            units: `${toInt(item.units)}pcs`,
        });
    });

    let tableY = 100
    doc.table(
        10,
        tableY,
        data,
        header,
        {
            autoSize: false,
            fontSize: 10,
            padding: 4,
            rowStart: (e) => {
                tableY += 8
            },
        }
    )

    header = [
        {
            'name': 'index',
            'prompt': "Carton No",
            'width': 20,
            'align': 'left',
        }, {
            'name': "weight",
            'prompt': "Weight",
            'width': 60,
            'align': 'right',
        }, {
            'name': "dimension",
            'prompt': "Dimension",
            'width': 80,
            'align': 'right',
        }
    ];
    data = []
    shipment.cartons.forEach((carton, index) => {
        data.push({
            index: `${index + 1}`,
            weight: `${carton.weight} KG`,
            dimension: `${carton.dimension} cm`,
        });
    });

    doc.setFontSize(12);
    doc.text("Carton Details", 10, tableY + 32);
    doc.setFontSize(10);
    doc.table(
        10,
        tableY + 35,
        data,
        header,
        {
            autoSize: false,
            fontSize: 10,
            padding: 4,
            margins: { left: 0, top: 10, bottom: 10 }
        }
    );

    // Next Page - Invoice
    // doc.addPage('a4', "p")
    // startX = 10;
    // startY = 10;
    // endX = doc.internal.pageSize.width - 20;
    // endY = doc.internal.pageSize.height - 20;
    // doc.rect(startX, startY, endX, endY);

    // //Heading Section
    // contentEndX = endX + 10;
    // contentEndY = endY + 10;
    // let headingHeight = 50;
    // let footerheightY = contentEndY - 50;
    // let footerTotalHeightY = contentEndY - 40;
    // doc.line(startX, headingHeight, contentEndX, headingHeight);
    // contentcenter = startX + (contentEndX - 10) / 2;

    // doc.setFont("times", '', 'normal')
    // doc.setFontSize(14);
    // doc.text(`${shipment.interstate === 1 ? 'TAX INVOICE' : 'Delivery Challan'}`, contentcenter, startX + 8, { align: "center", maxWidth: contentEndX - 10 });
    // doc.setFont("times", 'bold')
    // doc.setFontSize(32);
    // doc.text(company.name, contentcenter, startX + 19, { align: "center", maxWidth: contentEndX - 10 });
    // doc.setFont("times", '', 'normal')
    // doc.setFontSize(12);
    // doc.text(warehouse.address1, contentcenter, startX + 25, { align: "center", maxWidth: contentEndX - 10 });
    // doc.text(`${warehouse.address2 ? `${warehouse.address2}, ` : ''}${warehouse.city ? `${warehouse.city}, ` : ''}${warehouse.district ? `${warehouse.district}, ` : ''}${warehouse.state ? `${warehouse.state} ` : ''}${warehouse.pin ? `- ${warehouse.pin}` : ''}`, contentcenter, startX + 30, { align: "center", maxWidth: contentEndX - 10 });
    // doc.setFont("times", 'bold')
    // doc.text(`GSTIN No ${warehouse.gst}`, contentcenter, startX + 37, { align: "center", maxWidth: contentEndX - 10 });


    // //Bill to, Invoice, Date Section
    // let section2Height = headingHeight + 45;
    // let invoiceStartX = contentEndX - 65;
    // let invoiceStartY = headingHeight + 20;
    // doc.line(startX, section2Height, contentEndX, section2Height);
    // doc.line(invoiceStartX, invoiceStartY, contentEndX, invoiceStartY);
    // doc.line(invoiceStartX, headingHeight, invoiceStartX, section2Height);

    // // Bill To
    // doc.setFont("times", 'bold')
    // doc.setFontSize(12);
    // doc.text('Bill To:', startX + 2, headingHeight + 5, { align: "left", maxWidth: invoiceStartX - 10 });

    // doc.setFont("times", 'bold')
    // doc.setFontSize(12);
    // doc.text(company.bill_to, startX + 2, headingHeight + 12, { align: "left", maxWidth: invoiceStartX - 10 });

    // doc.setFont("times", '', 'normal')
    // doc.setFontSize(9);
    // doc.text(fc.name, startX + 2, headingHeight + 17, { align: "left", maxWidth: invoiceStartX - 10 });
    // doc.text(fc.address1, startX + 2, headingHeight + 22, { align: "left", maxWidth: invoiceStartX - 10 });
    // doc.text(fc.address2, startX + 2, headingHeight + 27, { align: "left", maxWidth: invoiceStartX - 10 });
    // doc.text(fc.address3, startX + 2, headingHeight + 32, { align: "left", maxWidth: invoiceStartX - 10 });
    // doc.text(fc.address4, startX + 2, headingHeight + 37, { align: "left", maxWidth: invoiceStartX - 10 });
    // doc.text(`GSTIN No: ${fc.gstin}`, startX + 2, headingHeight + 42, { align: "left", maxWidth: invoiceStartX - 10 });

    // //Invoice
    // doc.setFont("times", 'bold')
    // doc.setFontSize(12);
    // doc.text(`${shipment.interstate === 1 ? 'Invoice' : 'Challan'} No.`, invoiceStartX + 2, headingHeight + 5, { align: "left", maxWidth: contentEndX - 10 });
    // doc.setFont("times", '', 'normal')
    // doc.text(shipment.invoice_no, invoiceStartX + 2, headingHeight + 10, { align: "left", maxWidth: contentEndX - 10 });
    // if (shipment.interstate === 0) {
    //     doc.line(invoiceStartX, invoiceStartY - 7, contentEndX, invoiceStartY - 7);
    //     doc.text(`Vehicle No: ${shipment.vehicle_no || ''}`, invoiceStartX + 2, headingHeight + 18, { align: "left", maxWidth: contentEndX - 10 });
    // }

    // //Invoice Date
    // doc.setFont("times", 'bold')
    // doc.setFontSize(12);
    // doc.text('Date', invoiceStartX + 2, invoiceStartY + 5, { align: "left", maxWidth: contentEndX - 10 });
    // doc.setFont("times", '', 'normal')
    // doc.text(getTimeInIST(shipment.shipment_date).format(format_invoice), invoiceStartX + 2, invoiceStartY + 12, { align: "left", maxWidth: contentEndX - 10 });


    // //Table Heading
    // // let tableHeadingHeight = section2Height - 10;
    // let column1X = startX + 2;
    // let column2X = invoiceStartX - 46;
    // let column3X = invoiceStartX - 23;
    // let column4X = invoiceStartX - 10;
    // let column5X = invoiceStartX + 2;
    // let column6X = contentEndX - 43;
    // let column7X = contentEndX - 23;
    // let initialTableY = section2Height + 5;
    // doc.line(startX, section2Height + 10, contentEndX, section2Height + 10);

    // doc.line(contentEndX - 27, section2Height, contentEndX - 27, footerTotalHeightY);
    // doc.line(contentEndX - 48, section2Height, contentEndX - 48, footerTotalHeightY);
    // doc.line(invoiceStartX, section2Height, invoiceStartX, footerheightY);
    // doc.line(invoiceStartX - 13, section2Height, invoiceStartX - 13, footerheightY);
    // doc.line(invoiceStartX - 26, section2Height, invoiceStartX - 26, footerheightY);
    // doc.line(invoiceStartX - 48, section2Height, invoiceStartX - 48, footerheightY);

    // doc.setFont("times", 'bold')
    // doc.setFontSize(11);
    // doc.text('AMOUNT', column7X, initialTableY, { align: "left", maxWidth: contentEndX - 10 });
    // doc.text('RATE', column6X, initialTableY, { align: "left", maxWidth: contentEndX - 25 });
    // doc.text('UNITS', column5X, initialTableY, { align: "left", maxWidth: contentEndX - 45 });
    // doc.text('QTY', column4X, initialTableY, { align: "left", maxWidth: invoiceStartX + 4 });
    // doc.text('GST', column3X, initialTableY, { align: "left", maxWidth: invoiceStartX - 22 });
    // doc.text('HSN Code', column2X, initialTableY, { align: "left", maxWidth: invoiceStartX - 24 });
    // doc.text('Description of Goods', column1X, initialTableY, { align: "left", maxWidth: invoiceStartX - 50 });

    // // Items
    // doc.setFont("times", '', 'normal')
    // doc.setFontSize(10);
    // let item_lineheight = 5;
    // let initialTableDataHeight = initialTableY + 10;
    // shipment.items.forEach((item, index) => {
    //     let fnsku = master_items.filter(i => i.id === item.item_id)[0].fnsku;
    //     doc.text(`${index + 1}. ${item.item_name} [${fnsku}]`, startX + 1, initialTableDataHeight + (index * item_lineheight), { align: "left", maxWidth: 75 });
    //     doc.text(`${item.hsn_code}`, column3X - 4, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 23 });
    //     doc.text(`${shipment.interstate === 1 ? item.igst : parseFloat(item.cgst) + parseFloat(item.sgst)}%`, column4X - 4, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 12 });
    //     doc.text(`${toInt(item.units)}`, column5X - 3, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 12 });
    //     doc.text(`PCS`, column5X + 1, initialTableDataHeight + (index * item_lineheight), { align: "left", maxWidth: 20 });
    //     getRupeeSymbol(doc, column7X - 24, initialTableDataHeight + (index * item_lineheight));
    //     doc.text(` ${formatNumber(item.rate)}`, column7X - 5, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 20 });
    //     getRupeeSymbol(doc, column7X - 3, initialTableDataHeight + (index * item_lineheight));
    //     doc.text(` ${formatNumber(parseFloat(item.rate) * toInt(item.units))}`, contentEndX - 1, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 25 });
    // });

    // // Items Summary 
    // let summaryStart = startX + 1, summaryEnd = contentEndX - 1, summaryHeight = footerheightY - 45;
    // let roundOff = 0;
    // let total_amount = 0;
    // let igst_amount_map = new Map();
    // let cgst_amount_map = new Map();
    // let sgst_amount_map = new Map();
    // total_amount = shipment.items.reduce(function (items, item, idx) {
    //     return items + ((toInt(item.units)) * parseFloat(item.rate))
    // }, 0);
    // if (shipment.interstate === 1) {
    //     shipment.items.forEach(item => {
    //         if (!igst_amount_map.has(item.igst)) {
    //             igst_amount_map.set(item.igst, 0)
    //         }
    //     })
    //     igst_amount_map.forEach((value, key) => {
    //         igst_amount_map.set(key, shipment.items.filter(i => parseFloat(i.igst) === parseFloat(key)).reduce(function (items, item, idx) {
    //             let tax_rate = parseFloat(item.igst) / 100;
    //             return items + ((toInt(item.units) * item.rate) * tax_rate)
    //         }, 0))
    //     });
    // } else {
    //     shipment.items.forEach(item => {
    //         if (!cgst_amount_map.has(item.cgst)) {
    //             cgst_amount_map.set(item.cgst, 0)
    //             sgst_amount_map.set(item.sgst, 0)
    //         }
    //     })
    //     cgst_amount_map.forEach((value, key) => {
    //         cgst_amount_map.set(key, shipment.items.filter(i => parseFloat(i.cgst) === parseFloat(key)).reduce(function (items, item, idx) {
    //             let tax_rate = parseFloat(item.cgst) / 100;
    //             return items + ((toInt(item.units) * item.rate) * tax_rate)
    //         }, 0));
    //     });
    //     sgst_amount_map.forEach((value, key) => {
    //         sgst_amount_map.set(key, shipment.items.filter(i => parseFloat(i.sgst) === parseFloat(key)).reduce(function (items, item, idx) {
    //             let tax_rate = parseFloat(item.sgst) / 100;
    //             return items + ((toInt(item.units) * item.rate) * tax_rate)
    //         }, 0))
    //     });
    // }
    // let total_igst = Array.from(igst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
    // let total_cgst = Array.from(cgst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
    // let total_sgst = Array.from(sgst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
    // let total = Math.round(total_amount + (shipment.interstate === 1 ? (total_igst) : (total_cgst + total_sgst)));
    // roundOff = total - (total_amount + (shipment.interstate === 1 ? (total_igst) : (precision(total_cgst) + precision(total_sgst))));
    // summaryHeight = (total_cgst > 0) ? summaryHeight : summaryHeight + 5;
    // doc.setFont("times", 'bold')
    // doc.setFontSize(10);
    // doc.text('Total Taxable Value', summaryStart, summaryHeight, { align: "left", maxWidth: 77 });
    // getRupeeSymbol(doc, summaryEnd - 25, summaryHeight);
    // doc.text(`${formatNumber(total_amount)}`, summaryEnd, summaryHeight, { align: "right", maxWidth: 25 });

    // if (shipment.interstate === 1) {
    //     let i = 0
    //     igst_amount_map.forEach((value, key) => {
    //         doc.text(`ADD IGST  ${key}%`, summaryStart, summaryHeight + 5 + (i * 5), { align: "left", maxWidth: 77 });
    //         getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 5 + (i * 5));
    //         doc.text(`${formatNumber(value)}`, summaryEnd, summaryHeight + 5 + (i * 5), { align: "right", maxWidth: 25 });
    //         i++
    //     })
    // } else {
    //     let i = 0
    //     cgst_amount_map.forEach((value, key) => {
    //         let sgst = sgst_amount_map.get(key)
    //         doc.text(`ADD CGST  ${key}%`, summaryStart, summaryHeight + 5 + (i * 10), { align: "left", maxWidth: 77 });
    //         doc.text(`ADD SGST  ${key}%`, summaryStart, summaryHeight + 10 + (i * 10), { align: "left", maxWidth: 77 });

    //         getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 5 + (i * 10));
    //         doc.text(`${formatNumber(value)}`, summaryEnd, summaryHeight + 5 + (i * 10), { align: "right", maxWidth: 25 });
    //         getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 10 + (i * 10));
    //         doc.text(`${formatNumber(sgst)}`, summaryEnd, summaryHeight + 10 + (i * 10), { align: "right", maxWidth: 25 });
    //         i++
    //     })
    // }

    // let round_off_height = (total_igst === 0) ? summaryHeight + 24 : summaryHeight + 18;
    // doc.text('ROUND OFF', summaryStart, round_off_height, { align: "left", maxWidth: 77 });
    // getRupeeSymbol(doc, summaryEnd - 25, round_off_height);
    // doc.text(`${formatNumber(roundOff)}`, summaryEnd, round_off_height, { align: "right", maxWidth: 25 });

    // // Items Reference Section
    // let referenceStart = startX + 1, referenceHeight = footerheightY - 12;
    // doc.setFont("times", 'bold')
    // doc.setFontSize(10);
    // doc.text('Reference', referenceStart, referenceHeight, { align: "left", maxWidth: 77 });
    // doc.setFontSize(10);
    // doc.setFont("times", '', 'normal')
    // doc.text(`Shipment ID: ${shipment.shipment_identifier || ''}`, referenceStart, referenceHeight + 5, { align: "left", maxWidth: 75 });
    // doc.text(`Units: ${total_units}, Cartons: ${total_cartons}`, referenceStart, referenceHeight + 10, { align: "left", maxWidth: 75 });
    // // doc.text(, referenceStart, referenceHeight + 15, { align: "left", maxWidth: 75 });


    // // Footer
    // let totalInWordsSectionX = invoiceStartX - 48;
    // let totalInWordsSectionY = footerheightY + 30;
    // doc.line(startX, footerheightY, contentEndX, footerheightY);
    // doc.line(startX, footerTotalHeightY, contentEndX, footerTotalHeightY);
    // doc.line(startX, totalInWordsSectionY, totalInWordsSectionX, totalInWordsSectionY);
    // doc.line(startX, totalInWordsSectionY + 11, totalInWordsSectionX, totalInWordsSectionY + 11);
    // doc.line(totalInWordsSectionX, footerTotalHeightY, totalInWordsSectionX, contentEndY);

    // doc.setFont("times", 'bold')
    // doc.setFontSize(10);
    // doc.text(`Total`, startX + 2, footerheightY + 6, { align: "left" });
    // getRupeeSymbol(doc, contentEndX - 26, footerheightY + 5.75);
    // doc.text(`${formatNumber(total)}`, contentEndX - 1, footerheightY + 6, { align: "right", maxWidth: 25 });

    // doc.setFont("times", '', 'normal')
    // doc.setFontSize(10);
    // doc.text(`Amount (in words)`, startX + 2, footerheightY + 15, { align: "left" });
    // doc.setLineHeightFactor(1)
    // doc.text(`Rupees ${titleCase(numberToText(total))} only`, startX + 2, footerheightY + 20, { align: "left", maxWidth: totalInWordsSectionX - 15 });

    // doc.setFont("times", 'bold')
    // doc.setFontSize(12);
    // doc.text(`Company's PAN: ${company.pan}`, startX + 2, totalInWordsSectionY + 7, { align: "left" });
    // doc.text(`Buyer's PAN: ${company.pan}`, startX + 2, totalInWordsSectionY + 17, { align: "left" });


    // doc.setFont("times", '', 'normal')
    // doc.setFontSize(12);
    // doc.text(`For ${company.name}`, contentEndX - 5, footerheightY + 24, { align: "right" });
    // doc.text(`Authorised Signatory`, contentEndX - 5, totalInWordsSectionY + 15, { align: "right" });


    // doc.output("dataurlnewwindow");


    // doc.save("Invoice-"+shipment.invoice_no);
    // var output = doc.output('datauristring');
    // this.setState({output: output});

    let filename = `${shipment.shipment_identifier || ''}_${shipment.fc_name}_GST${shipment.invoice_no.substring(shipment.invoice_no.lastIndexOf("/") + 1)}_Invoice.pdf`;
    doc.save(filename);
}